import { JsonProperty } from 'json-typescript-mapper';

export class Weather {

  @JsonProperty('weather_id')
  public weatherId?: string;

  @JsonProperty('latitude')
  public latitude?: number;

  @JsonProperty('longitude')
  public longitude?: number;

  @JsonProperty('weatherJson')
  public weatherJson?: string;

  @JsonProperty('weather_primary')
  public weatherPrimary?: string;

  @JsonProperty('weather_description')
  public weatherDescription?: string;

  @JsonProperty('temperature')
  public temperature?: number;

  @JsonProperty('temperature_min')
  public temperatureMin?: number;

  @JsonProperty('temperature_max')
  public temperatureMax?: number;

  @JsonProperty('pressure')
  public pressure?: number;

  @JsonProperty('humidity')
  public humidity?: number;

  @JsonProperty('wind_speed')
  public windSpeed?: number;

  @JsonProperty('wind_degrees')
  public windDegrees?: number;

  constructor() {
    this.weatherId = void 0;
    this.latitude = void 0;
    this.longitude = void 0;
    this.weatherJson = void 0;
    this.weatherPrimary = void 0;
    this.weatherDescription = void 0;
    this.temperature = void 0;
    this.temperatureMin = void 0;
    this.temperatureMax = void 0;
    this.pressure = void 0;
    this.humidity = void 0;
    this.windSpeed = void 0;
    this.windDegrees = void 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/weather.model.ts